import { createSelector } from '@reduxjs/toolkit';
const reduxFlagsReducer = (state) => state.reduxFlags;
export const reduxFlagsDataSelector = createSelector(reduxFlagsReducer, (reducer) => reducer.data);
